import { IconButton, Tooltip } from "@mui/material";
import colors from "assets/theme/base/colors";
import Iconify from "components/Iconify";
import MDBox from "components/MDBox";
import React from "react";
import EditButtonIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import VerifiedIcon from "@mui/icons-material/Verified";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import AddCircleIcon from "@mui/icons-material/AddCircle";

const MDActionButton = ({ type, onClick }) => {
  const { error, info } = colors;
  return (
    <MDBox>
      {type === "edit" && (
        <Tooltip title="Edit" placement="top" arrow>
          <IconButton color="inherit" onClick={onClick}>
            <EditButtonIcon />
            {/* <Iconify icon="solar:pen-bold" /> */}
          </IconButton>
        </Tooltip>
      )}
      {type === "delete" && (
        <Tooltip title="Delete" placement="top" arrow>
          <IconButton color="inherit" onClick={onClick}>
            <DeleteIcon sx={{ color: error.main }} />
            {/* <Iconify icon="solar:trash-bin-trash-bold" sx={{ color: error.main }} /> */}
          </IconButton>
        </Tooltip>
      )}
      {type === "download" && (
        <Tooltip title="Download" placement="top" arrow>
          <IconButton sx={{ color: "#9A3B3B" }} color="inherit" onClick={onClick}>
            <DownloadIcon />
            {/* <Iconify icon="line-md:downloading-loop" /> */}
          </IconButton>
        </Tooltip>
      )}
      {type === "verify" && (
        <Tooltip title="Verify" placement="top" arrow>
          <IconButton sx={{ color: "green" }} color="inherit" onClick={onClick}>
            <VerifiedIcon />
            {/* <Iconify icon="mdi:check-circle-outline" /> */}
          </IconButton>
        </Tooltip>
      )}
      {type === "reset" && (
        <Tooltip title="Reset" placement="top" arrow>
          <IconButton color="inherit" onClick={onClick}>
            <RestartAltIcon />
            {/* <Iconify icon="mdi:check-circle-outline" /> */}
          </IconButton>
        </Tooltip>
      )}
      {type === "add" && (
        <Tooltip title="Add" placement="top" arrow>
          <IconButton color="inherit" onClick={onClick}>
            <AddCircleIcon />
            {/* <Iconify icon="mdi:check-circle-outline" /> */}
          </IconButton>
        </Tooltip>
      )}
    </MDBox>
  );
};

export default MDActionButton;
